import { useAuth } from '@frontegg/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const ReferralSignup = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    } else {
      window.location.href = `${import.meta.env.VITE_FRONTEGG_BASE_URL}/oauth/account/sign-up`;
    }
  }, [isAuthenticated, navigate]);

  return null;
};
